import React from 'react'

import { Helmet } from 'react-helmet'

import PagesliderStigma from '../components/pageslider-stigma'
import './stigma.css'

const Stigma = (props) => {
  return (
    <div className="stigma-container">
      <Helmet>
        <title>Stigma - ORRS</title>
        <meta property="og:title" content="Stigma - ORRS" />
      </Helmet>
      <div className="home-header">
        <div className="header-content">
            <img id="logo" src="\external\ORRSLogos_1113.png" alt="Logo" />
            <h1 className="home-text">The Opioid Rapid Response System (ORRS)<sup className='trademark'>TM</sup></h1>
        </div>
    </div>
      <PagesliderStigma rootClassName="pageslider-cpr-root-class-name1"></PagesliderStigma>
      <footer className="stigma-footer">
        <span className="stigma-text2">
          <span>
            The contents of this training were created by REAL Prevention. For
            inquiries on permission for use of these materials please contact
          </span>
          <span className="stigma-text4">hechtpsu@gmail.com.</span>
        </span>
        <span className="stigma-text6 Content">
          Copyright (2021) REAL Prevention. All rights reserved.
        </span>
      </footer>
    </div>
  )
}

export default Stigma
